import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ROUTES } from '@constants/index'
import { showApp, appErrorSelector, setAppVisibleAllowed } from '@redux/slices'
import { usePathBuilder } from './usePathBuilder'
import { useAppNavigate } from './useAppNavigate'

export const useAppErrorHandler = () => {
  const buildPath = usePathBuilder()
  const navigate = useAppNavigate()
  const dispatch = useDispatch()
  const error = useSelector(appErrorSelector)

  useEffect(() => {
    if (error?.errorType) {
      setAppVisibleAllowed()
      dispatch(showApp())
      navigate(buildPath(ROUTES.ERROR))
    }
  }, [dispatch, buildPath, navigate, error])
}
